<template>
  <div class="container">
    <div class="header">
        <div class="logo">
          <img class="img" src="../../assets/logo1.png" />
        </div>
        <div class="nav">
          <div class="search-container">
            <el-input
              class="input"
              placeholder="请输入查询内容"
              v-model="searchModel"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click.prevent="search"
              ></i>
            </el-input>
          </div>
          <div class="nav-container">
            <div class="nav-item" v-for="(item, index) in navs" :key="index" @click="link">
              <router-link :to="{ path: item.url }">{{
                item.text
              }}</router-link>
            </div>
          </div>
        </div>
      
    </div>
    <div class="content">
      <router-view />
    </div>
    <div class="footer">
      <div
        style="
          width: 80%;
          display: flex;
          flex-direction: row;
          margin: auto;
          justify-content: space-around;
        "
      >
        <div class="footer-logo">
          <img class="img" src="../../assets/footer-logo.png" />
        </div>
        <div class="line"></div>
        <div class="footer-content">
          <p>
            互联网出版许可证：（总）网出证（辽）字第009号 <a style="color:#fff" href="https://beian.miit.gov.cn/" target="_blank">辽ICP备20010852号-7</a>
            <br />互联网新闻信息服务许可证编号：50120180007
            <br />联系电话：024-83777210
            技术支持：博雅数字（辽宁）经济发展有限公司 
            <br />Copyright© 2021 中国（辽宁）自由贸易试验区沈阳片区非公企业党建 版权所有
            
          </p>
        </div>
        <div class="footer-qrcode">
          <img class="img" src="../../assets/qrcode.png" />
        </div>
        <div class="footer-img">
          <img class="img" src="../../assets/dangzheng.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      searchModel: "",
    };
  },
  computed: {
    ...mapGetters({
      navs: "navs",
    }),
  },
  async created() {
    await this.init();
    this.$nextTick(async () => {
      await this.init();
    });
  },
  methods: {
    ...mapActions({
      getColumns: "getColumns",
    }),
    link(){
      localStorage.removeItem("SET_HOMENEWS")
    },
    // 搜索
    search() {
      let serarchData = this.searchModel;
      if (serarchData) {
        this.$router.push({ path: "/search", query: { search: serarchData } });
      } else {
        this.$notify({
          title: "警告",
          message: "请输入关键字",
          type: 'warning'
        });
      }
      
      // let tempwindow = window.open("_blank");
      // tempwindow.location = 'https://www.lndj.gov.cn/lsdjportal/'
    },
    async init() {
      await this.getColumns();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  overflow-y: auto;
  position: relative;
  .common {
    width: 100%;
  }

  .content {
    width: 100%;
    max-width: 1346px;
    margin: 38px auto;
  }

  .footer {
    height: 136px;
    background-image: url("../../assets/footer-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .common;
    .footer-img {
      height: 136px;
      img {
        width: 52px;
        height: 63px;
        margin-top: 39px;
        margin-left: 50px;
      }
    }
    .footer-qrcode{
      height: 136px;
      img {
        width: 120px;
        height: 120px;
        margin-top: 10px;
      }
    }

    .footer-content {
      height: 136px;
      font-weight: 400;
      position: relative;
      color: #ffffff;
      font-size: 14px;
      line-height: 24px;
      p {
        margin-top: 30px;
        width: 600px;
      }
    }

    .line {
      width: 1px;
      height: 61px;
      background-color: #ffffff;
      opacity: 0.5;
      margin: auto 20px;
    }

    .footer-logo {
      .img {
        margin-top: 41px;
        width: 323px;
        height: 55px;
      }
    }
  }

  .header {
    height: 184px;
    position: relative;
    display: flex;
    background-image: url("../../assets/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    justify-content: space-around;

    .common;
    .logo {
      width: 471px;
      height: 184px;
      .img {
        margin-top: 63px;
        width: 471px;
        height: 80px;
      }
    }
    .nav {
      width: 803px;
      position: relative;
      .nav-container {
        width: 803px;
        height: 20px;
        bottom: 42px;
        position: absolute;
        display: flex;
        .nav-item {
          width: 12.5%;
          text-align: center;
          font-size: 20px;
          line-height: 20px;
          a {
            color: #ffffff;
          }
        }
      }
      .search-container {
        width: 803px;
        margin-top: 40px;
        text-align: right;
        .input {
          width: 296px;
          height: 32px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>